module.exports = __webpack_public_path__ + "img/_voice_on.115ea643.svg";